// extracted by mini-css-extract-plugin
export default {"modelName":"ModelSwitcher-module__modelName__NHhNpTy","selectAnchor":"ModelSwitcher-module__selectAnchor__LSDCXYT"};